<template>
    <div style="padding:15px;background: #fff;min-height: calc(100% - 30px);" >
        <div style="border-bottom:1px solid #eaeaea;">
            <h1 style="margin-top:0px; text-align:center;">{{banner.title}}</h1>
            <p style="text-align:right;">{{banner.created_at}}</p>
        </div>
        <div v-html="banner.detail" class="detail"></div>
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "Banner",
        data(){
            return {
                banner: '',
            };
        },
        created() {
            let url = window.location.href ; //获取url中"?"符后的字串
            let company_id = url.split('?id=')[1];
            api.request('/banner/detail', {
                id : company_id,
            }).then(res => {
                this.banner =res.data;
            });
        }
    }
</script>

<style lang="scss" scoped>
    .detail {
        overflow-x: hidden;
        >>>blockquote {
            border-left: 8px solid #d0e5f2;
            padding: 5px 10px;
            margin: 10px 0;
            font-size: 100%;
            line-height: 1.6;
            background-color: #f1f1f1;
            display: block;
        }
        >>>ol {
            display: block;
            list-style-type: decimal;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            padding-inline-start: 20px;
            li { 
                display: list-item;
                text-align: -webkit-match-parent;
            }
        }

        >>>ul {
            display: block;
            list-style-type: disc;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            padding-inline-start: 20px;
            li { 
                display: list-item;
                text-align: -webkit-match-parent;
            }
        }

        >>>table {
            border-top: 1px solid #ccc;
            border-left: 1px solid #ccc;
            padding: 0;
            margin: 0;
            box-sizing: border-box;
            th {
                text-align: center;
            }
            th, td {
                border-bottom: 1px solid #ccc;
                border-right: 1px solid #ccc;
                padding: 3px 5px;
            }
        }

        >>>img {
            max-width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Banner.vue